<script setup lang="ts">
import Icon from '../Icon.vue';

const props = withDefaults(defineProps<{
	title: string;
	subtitle?: string;
	description?: string;
	currentStep?: number;
	totalSteps?: number;
}>(), {
	currentStep: 1,
});

defineEmits<{
	backPressed: [void];
}>();
</script>

<template>
	<div class="entry-card-content">
		<div class="entry-card-content__content">
			<div class="entry-card-content__steps" v-if="props.totalSteps">
				<button
					class="entry-card-content__return"
					type="button"
					v-if="props.currentStep > 1"
					@click="$emit('backPressed')"
				>
					<Icon name="arrow-left" />
					<span>Step {{ props.currentStep }} of {{ props.totalSteps }}</span>
				</button>
				<template v-else>
					<span>Step {{ props.currentStep }} of {{ props.totalSteps }}</span>
				</template>
			</div>
			<span class="entry-card-content__title">{{ props.title }}</span>
			<span class="entry-card-content__subtitle" v-if="props.subtitle">{{ props.subtitle }}</span>
		</div>
		<div class="entry-card-content__description" v-if="props.description">
			<span>{{ props.description }}</span>
			<slot name="actions" v-if="$slots.actions" />
		</div>
	</div>
</template>

<style scoped lang="scss">
@layer hm-components
{
	.entry-card-content
	{
		@include flex(null, null, var(--spacing-md));
		flex-direction:column;
		padding-block-end:var(--spacing-xl);

		&__steps
		{
			color:var(--c-title);
			@include text-overline(sm);
			font-weight:600;
			padding-block-end:var(--spacing-sm);
		}
		&__return
		{
			@include flex(null, center, var(--spacing-2xs));

			&:deep(.icon)
			{
				@include svg(16);
			}
		}
		&__content
		{
			@include flex;
			flex-direction:column;
		}
		&__title
		{
			@include text-title-entry;
		}
		&__subtitle
		{
			color:var(--c-title);
			@include text-body(md);
		}
		&__description
		{
			@include flex(null, center, var(--spacing-4xs));
			color:var(--c-title);
			@include text-body(sm);
		}
	}
}
</style>
